import { render, staticRenderFns } from "./FontPairingEditForm.vue?vue&type=template&id=2645fcbe"
import script from "./FontPairingEditForm.vue?vue&type=script&lang=js"
export * from "./FontPairingEditForm.vue?vue&type=script&lang=js"
import style0 from "./FontPairingEditForm.vue?vue&type=style&index=0&id=2645fcbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports